<template>
  <v-card class="mx-auto br-3">
    <v-card-title class="pb-0">
      <v-icon
        size="32"
        left
      >
        mdi-shuffle-variant
      </v-icon>
      <span class="subtitle-1">{{ $t('Zawor 3d4d') }}</span>
    </v-card-title>

    <v-card-text class="pb-0">
      <div class="d-flex flex-row align-center">
        <div class="w-mode text-center">
          <v-btn
            :color="(coMode != 0) ? 'primary' : ''"
            rounded
            large
            depressed
          >
            {{ coMode }}%
          </v-btn>
        </div>
        <div class="d-flex flex-column w-set pa-0 text-center font-weight-medium subtitle-1">
          <div class="accent--text">{{ parseInt(this.params.valveTempSet) }} &deg;C</div>
          <div class="secondary--text">{{ parseInt(this.params.valveTempReduced) }} &deg;C</div>
        </div>
        <v-card flat ripple :to="(permission == 0 || permission == 1) ? '/dashboard/valve-temp/'+controllerId : '/dashboard/'+controllerId" class="w-read">
          <v-gauge :value="valveTemp" :minValue="tempMin" :maxValue="tempMax" :decimalPlace="0" :options="gOptions" height="250" />
          <div class="unit">&deg;C</div>
        </v-card>
      </div>
    </v-card-text>

    <v-card-actions class="pt-0">
      <v-btn v-if="valveCalendar !== undefined"
      icon large 
      :color="(valveCalendar == 1) ? 'primary' : 'info'" 
      :loading="savingCalendar"
      :disabled="savingCalendar"
      @click="calendarSheet = (permission == 0 || permission == 1) ? !calendarSheet : calendarSheet" class="key-btn">
        <v-icon>mdi-calendar-month</v-icon>
      </v-btn>
      <v-btn v-if="valveWeatherMode !== undefined"
      icon large 
      :color="(valveWeatherMode == 1) ? 'primary' : 'info'" 
      :loading="savingWeatherMode"
      :disabled="savingWeatherMode"
      @click="weatherSheet = (permission == 0 || permission == 1) ? !weatherSheet : weatherSheet" class="key-btn">
        <v-icon>mdi-weather-snowy</v-icon>
      </v-btn>
      <div class="flex-grow-1"></div>
    </v-card-actions>

    <v-bottom-sheet v-model="calendarSheet">
      <v-sheet>
        <div class="px-4 pt-6 pb-3">
          <v-toolbar flat>
            <v-toolbar-title class="subtitle-1">{{ $t('tryb-kal') }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-btn icon @click="calendarSheet = !calendarSheet">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-list flat>
            <v-list-item ripple class="br-3 selected">
              <v-list-item-icon>
                <v-icon>mdi-calendar-month</v-icon>
              </v-list-item-icon>
              <v-list-item-content @click="onChangeCalendar">
                <v-list-item-title class="title">{{ $t('wlacz') }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch :input-value="calendarSetting" color="primary" @change="onChangeCalendar"></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-list-item :to="'/dashboard/valve-calendar/'+controllerId" class="br-3">
              <v-list-item-icon>
                <v-icon>mdi-settings</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="title">{{ $t('Ustawienia') }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </div>
      </v-sheet>
    </v-bottom-sheet>

    <v-bottom-sheet v-model="weatherSheet">
      <v-sheet>
        <div class="px-4 pt-6 pb-3">
          <v-toolbar flat>
            <v-toolbar-title class="subtitle-1">{{ $t('tryb-pog') }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-btn icon @click="weatherSheet = !weatherSheet">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-list flat>
            <v-list-item ripple class="br-3 selected">
              <v-list-item-icon>
                <v-icon>mdi-weather-snowy</v-icon>
              </v-list-item-icon>
              <v-list-item-content @click="onChangeWeatherMode">
                <v-list-item-title class="title">{{ $t('wlacz') }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch :input-value="weatherModeSetting" color="primary" @change="onChangeWeatherMode"></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-list-item :to="'/dashboard/valve-weather/' + controllerId" class="br-3">
              <v-list-item-icon>
                <v-icon>mdi-settings</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="title">{{ $t('Ustawienia') }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </div>
      </v-sheet>
    </v-bottom-sheet>

  </v-card>
</template>

<script>
import VGauge from "vgauge";
export default {
  components: {
    VGauge
  },
  data: () => ({
    savingCoMode: false,
    more: false,
    calendarSheet: false,
    calendarSetting: false,
    savingCalendar: false,
    weatherSheet: false,
    weatherModeSetting: false,
    savingWeatherMode: false
  }),
  computed: {
    params () {
      return this.$store.state[this.moduleName].params
    },
    valveTemp () {
      return parseInt(this.params.valveTemp)
    },
    blowPower () {
      return parseInt(this.params.blowPower)
    },
    boilerPower () {
      return parseInt(this.params.boilerPower)
    },
    valveCalendar () {
      return (this.params.valveCalendar !== undefined) ? parseInt(this.params.valveCalendar) : undefined
    },
    valveWeatherMode () {
      return (this.params.valveWeatherMode !== undefined) ? parseInt(this.params.valveWeatherMode) : undefined
    },
    coMode () {
      return parseInt(this.params.coMode)
    },
    tempMin() {
      return this.$store.state[this.moduleName].boilerTempMin
    },
    tempMax() {
      return this.$store.state[this.moduleName].boilerTempMax
    },
    dark() {
      return this.$store.state.user.dark;
    },
    gOptions() {
      return {
        angle: -0.18,
        lineWidth: 0.18,
        pointer: {
          length: 0,
          strokeWidth: 0
        },
        colorStart: (this.dark) ? '#EF5350' : '#EF3024',
        strokeColor: (this.dark) ? 'rgba(0,0,0,0.3)' : '#E0E0E0'
      }
    }
  },
  created () {
    this.calendarSetting = (this.valveCalendar == 1) ? true : false;
    this.weatherModeSetting = (this.valveWeatherMode == 1) ? true : false;
  },
  props: ['moduleName','controllerId','permission','loading'],
  methods: {
    onChangeCalendar() {
      this.calendarSetting = !this.calendarSetting;
      this.setCalendar((this.calendarSetting) ? 1 : 0);
    },
    setCalendar(mode) {
      this.savingCalendar = true;
      setTimeout(() => { this.calendarSheet = false; }, 300);
      this.$store.dispatch(`${this.moduleName}/setValveCalendar`, mode)
      .then(res => {
        this.savingCalendar = false;
        if (res.error) {
          this.$store.commit("alert", {
            color: "error",
            text: res.error.code
          });
          this.calendarSetting = (this.valveCalendar == 1) ? true : false;
        }
      });
    },
    onChangeWeatherMode() {
      this.weatherModeSetting = !this.weatherModeSetting;
      this.setWeatherMode((this.weatherModeSetting) ? 1 : 0);
    },
    setWeatherMode(mode) {
      this.savingWeatherMode = true;
      setTimeout(() => { this.weatherSheet = false; }, 300);
      this.$store.dispatch(`${this.moduleName}/setValveWeatherMode`, mode)
      .then(res => {
        this.savingWeatherMode = false;
        if (res.error) {
          this.$store.commit("alert", {
            color: "error",
            text: res.error.code
          });
          this.weatherModeSetting = (this.valveWeatherMode == 1) ? true : false;
        } else {
          setTimeout(() => { 
            this.$store.dispatch(`${this.moduleName}/syncController`, true); //odswiez zeby pokazac pompy
          }, 5000);
        }
      });
    },
    gotoDash (id) {
      this.$router.push({ path: '/dashboard/'+id });
    }
  }
  
}
</script>

<style>
</style>